import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiService {
   baseUrl = environment.apiUrl;

  private selectedProduct = new Subject<any>();
  productSelected = this.selectedProduct.asObservable();
  

  constructor(private http: HttpClient) {}

  getProductAlias() {
    return this.http.get(this.baseUrl + `productalias/`);
  }

  getCompanies() {
    return this.http.get(this.baseUrl + `manufacturers/`);
  }

  searchProducts(searchString) {
    return this.http.get(this.baseUrl + `products/search?=${searchString}`);
  }

  selectProduct(product) {
    this.selectedProduct.next(product);
  }

  getProducts() {
    return this.http.get(this.baseUrl + 'products/getAllProducts')
  }
  
  assignProductLocation(model: any){
    return this.http.post(this.baseUrl + 'products/assignProductToLocation',  model);
  }
}